<template>
  <div>
    <template v-if="institution && !institution.kl_assessment">
      <Page404></Page404>
    </template>
    <template v-else>
      <NewEvaluation
        :allows_crud="false"
        :evaluation_id="evaluation_id"
        :instrument_id="instrument_id"
        :evaluatee_view="true"
      ></NewEvaluation>
    </template>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import matterLanguageMixin from "@/mixins/matterLanguageMixin";

export default {
  name: "EvaluateeView",
  mixins: [matterLanguageMixin],
  components: {
    NewEvaluation: () =>
      import("@/components/new-evaluations/Evaluation/NewEvaluation"),
    Page404: () => import("@/components/public/Page404"),
  },
  props: {},
  data() {
    return {
      evaluation_id: Number(this.$route.params.evaluation_id),
      instrument_id: Number(this.$route.params.instrument_id),
    };
  },
  computed: {
    ...mapGetters({
      institution: "getInstitution",
      user: "getUser",
    }),
  },
  methods: {},
  mounted() {},
  watch: {},
  created() {
    this.$store.dispatch(names.FETCH_NEW_TEST_TYPES);
    this.$store.dispatch(names.FETCH_REDACTION_QUESTION_LENGTH_ANSWERS);
    this.$store.dispatch(names.FETCH_MULTIPLE_QUESTION_SCORE_TYPES);
    this.$store.dispatch(names.FETCH_RUBRIC_PRESETS);
    this.$store.dispatch(names.FETCH_RUBRIC_PRESET_UNITS);
    this.$store.dispatch(names.FETCH_NEW_FILLING_QUESTION_SUB_TYPES);
    this.$store.dispatch(names.FETCH_TAXONOMIES);
    this.$store
      .dispatch(names.FETCH_NEW_EVALUATION, this.evaluation_id)
      .then((evaluation) => {
        this.applyLanguageForEvaluation(evaluation);
      });
  },
};
</script>

<style scoped>
</style>